import { 
  Smartphone, 
  HardDrive, 
  MessageSquare, 
  ShieldAlert, 
  Scan,
  Fingerprint,
  FileSearch,
  Bot
} from "lucide-react";

const iconMap = {
  "hard-drive": HardDrive,
  "message-square": MessageSquare,
  "shield-alert": ShieldAlert,
  "bot": Bot,
  "fingerprint": Fingerprint,
  "file-search": FileSearch,
  "scan": Scan
};

const Services = ({ content }) => {
  const servicesContent = content || {
    section_label: "Servicios Especializados",
    title: "Soluciones de peritaje informatico para cada necesidad",
    subtitle: "Metodologia forense rigurosa adaptada a procedimientos civiles, penales, laborales y mercantiles.",
    main_services: [],
    additional_services_title: "Servicios Complementarios",
    additional_services: []
  };

  return (
    <section id="servicios" className="py-24 relative" data-testid="services-section">
      {/* Background */}
      <div className="absolute inset-0 gradient-overlay" />
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="max-w-2xl mb-16">
          <span className="text-sky-400 font-mono text-sm tracking-wider uppercase mb-4 block">
            {servicesContent.section_label}
          </span>
          <h2 className="font-outfit text-3xl sm:text-4xl font-bold text-white mb-6">
            {servicesContent.title}
          </h2>
          <p className="text-slate-400 text-lg leading-relaxed">
            {servicesContent.subtitle}
          </p>
        </div>

        {/* Main services grid — todas las cajas iguales */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {servicesContent.main_services?.map((service) => {
            const IconComponent = iconMap[service.icon] || HardDrive;
            return (
              <div
                key={service.id}
                className="card-service flex flex-col"
                data-testid={`service-card-${service.id}`}
              >
                {/* Icon */}
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-sm bg-slate-900 border border-slate-700 mb-4">
                  <IconComponent className="w-6 h-6 text-sky-400" />
                </div>

                {/* Content */}
                <h3 className="font-outfit font-semibold text-white text-lg mb-3">
                  {service.title}
                </h3>
                <p className="text-slate-400 text-sm mb-4 flex-grow">
                  {service.description}
                </p>

                {/* Features */}
                <ul className="space-y-2">
                  {service.features?.map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-sm text-slate-500">
                      <span className="w-1.5 h-1.5 rounded-full bg-sky-400 flex-shrink-0" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        {/* Additional services */}
        <div className="border-t border-slate-800 pt-12">
          <h3 className="font-outfit text-xl font-semibold text-white mb-8">
            {servicesContent.additional_services_title}
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {servicesContent.additional_services?.map((service, index) => {
              const IconComponent = iconMap[service.icon] || Fingerprint;
              return (
                <div
                  key={index}
                  className="flex items-start gap-4 p-4 rounded-sm border border-slate-800 hover:border-slate-700 transition-colors"
                  data-testid={`additional-service-${index}`}
                >
                  <div className="flex-shrink-0 w-10 h-10 rounded-sm bg-slate-800 flex items-center justify-center">
                    <IconComponent className="w-5 h-5 text-sky-400" />
                  </div>
                  <div>
                    <h4 className="font-medium text-white mb-1">{service.title}</h4>
                    <p className="text-sm text-slate-500">{service.description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
